// extracted by mini-css-extract-plugin
module.exports = {"head":"SelectionHead_head__xOQ0M","title":"SelectionHead_title__xYkiQ","link":"SelectionHead_link__c5yym","icon":"SelectionHead_icon__TTkdm"};